export default Object.freeze([
    'Visitor Overview',
    'Account Overview',
    'Weekly Visitors',
    'Weekly Accounts',
    'Browser Usage',
    'Page Overview',
    'Feature Overview',
    'Page Use by Account',
    'Feature Use by Account',
    'Active Unique Visitors Per Hour',
    'Guide Overview',
    'Most Seen Guides',
]);
